import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Divider,
} from '@mui/material';
import {
  Smartphone,
  ChangeCircle,
  AddModerator,
  MoreTime,
} from '@mui/icons-material';

import { Context } from '../context/DataContext';

const DashboardPage = () => {
  const navigate = useNavigate();
  const { state, setCustomerInfo } = React.useContext(Context);
  const { loginInfo = {} } = state;
  const { dealerNo, insuranceSellerNo, canSellNewExt, tokenLogin } = loginInfo;
  const serviceName =
    dealerNo === '017' || dealerNo === '008' ? '智慧保鏢' : '行動守護';
  const isOnlySellingExtendedWarranty = insuranceSellerNo === 'EXTWS';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        pt: 2,
      }}>
      <Typography
        variant='h4'
        sx={{ my: 2 }}>
        產品選擇
      </Typography>
      <Box
        sx={{
          width: '100%',
          maxWidth: 320,
          boxShadow: '0 0 0.4rem rgb(0 0 0 / 25%)',
          borderRadius: 2,
        }}>
        <List>
          {tokenLogin ? (
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => {
                  setCustomerInfo(
                    {
                      imeiServiceName: '新機延長保固',
                    },
                    () => {
                      navigate('/extend-new/check');
                    }
                  );
                }}>
                <ListItemIcon>
                  <MoreTime />
                </ListItemIcon>
                <ListItemText primary='新機延長保固' />
              </ListItemButton>
            </ListItem>
          ) : (
            <>
              {!isOnlySellingExtendedWarranty ? (
                <>
                  <ListItem disablePadding>
                    <ListItemButton
                      onClick={() => {
                        setCustomerInfo(
                          {
                            imeiServiceName: serviceName,
                          },
                          () => {
                            navigate('/specification');
                          }
                        );
                      }}>
                      <ListItemIcon>
                        <Smartphone />
                      </ListItemIcon>
                      <ListItemText primary={serviceName} />
                    </ListItemButton>
                  </ListItem>
                  <Divider />
                  <ListItem disablePadding>
                    <ListItemButton
                      onClick={() => {
                        setCustomerInfo(
                          {
                            imeiServiceName: serviceName,
                          },
                          () => {
                            navigate('/query-previous-order');
                          }
                        );
                      }}>
                      <ListItemIcon>
                        <ChangeCircle />
                      </ListItemIcon>
                      <ListItemText primary='換機' />
                    </ListItemButton>
                  </ListItem>
                  <Divider />
                  <ListItem disablePadding>
                    <ListItemButton
                      onClick={() => {
                        setCustomerInfo(
                          {
                            imeiServiceName: '竊盜險',
                          },
                          () => {
                            navigate('/burglary-insur/check');
                          }
                        );
                      }}>
                      <ListItemIcon>
                        <AddModerator />
                      </ListItemIcon>
                      <ListItemText primary='竊盜險' />
                    </ListItemButton>
                  </ListItem>
                  {canSellNewExt ? <Divider /> : null}
                </>
              ) : null}
              {canSellNewExt ? (
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      setCustomerInfo(
                        {
                          imeiServiceName: '新機延長保固',
                        },
                        () => {
                          navigate('/extend-new/check');
                        }
                      );
                    }}>
                    <ListItemIcon>
                      <MoreTime />
                    </ListItemIcon>
                    <ListItemText primary='新機延長保固' />
                  </ListItemButton>
                </ListItem>
              ) : null}
            </>
          )}
        </List>
      </Box>
    </Box>
  );
};

export default DashboardPage;
